import { Component, OnInit } from '@angular/core';
import { ProductService } from '../../services/productservice';
import { Product } from '../../domain/product';
import {MenuItem} from 'primeng/api';
import { trigger,state,style,transition,animate } from '@angular/animations';

@Component({
  selector: 'app-job-chain-cycle-report',
  templateUrl: './job-chain-cycle-report.component.html',
  styleUrls: ['./job-chain-cycle-report.component.scss'],
  animations: [
    trigger('rowExpansionTrigger', [
        state('void', style({
            transform: 'translateX(-10%)',
            opacity: 0
        })),
        state('active', style({
            transform: 'translateX(0)',
            opacity: 1
        })),
        transition('* <=> *', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)'))
    ])
]
})
export class JobChainCycleReportComponent implements OnInit {

  products: Product[];
  items: MenuItem[];
  basicData: any;
  basicOptions: any;

  constructor(private productService: ProductService) { }

  ngOnInit() {
    this.productService.getProductsSmall().then(data => this.products = data);
    this.items = [
      {label: 'Menu'},
      {label: 'Menu Active'},
  ];
  this.basicData = {
    labels: ['Step 1', 'Step 2', 'Step 3', 'Step 4', 'Step 5', 'Step 6', 'Step 7'],
    datasets: [
        {
            data: [3, 2, 3, 4, 3, 2, 4],
            fill: false,
            borderColor: '#94A3B8',
            tension: 0.4
        }
    ]
};
this.basicOptions = {
  legend: {
      position: 'bottom',
      display: false
  },
  scales: {
    yAxes: [{
      ticks: {
        stepSize: 1,
        beginAtZero: true,
      },
    }],
  },
};
}

}
